import React from 'react';
import { ThemeContext } from './ThemeContext';

export function useAppTheme() {
  const themeState = React.useContext(ThemeContext);
  return themeState.appTheme;
}
